var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('doctor-table',{attrs:{"canDelete":true,"viewRoute":"SuperAdminDoctorEdit","viewDetailRoute":"SuperAdminDoctorDetail","canCreate":true,"createRoute":"SuperAdminDoctorCreate","canRequestAssociation":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }